//
// refresh the captcha code every minute
//

var refreshCaptchaEveryMinute = (function () {
    'use strict';

    var inputs = $("input[data-sf-role='captcha-input']");
    var refreshButtons = $("a[data-sf-role='captcha-refresh-button']");

    const refreshPeriod = 60; // in seconds
    const refreshPeriodMilliseconds = refreshPeriod * 1000;

    function setCaptchaTimeout(input, refreshButton) {
        var timeoutId = 0;
        function refreshCaptcha() {
            $(refreshButton).click();
        }
        timeoutId = setInterval(refreshCaptcha, refreshPeriodMilliseconds);

        $(input).on("focus", function () {
            clearInterval(timeoutId);
        });

        $(input).on("blur", function () {
            timeoutId = setInterval(refreshCaptcha, refreshPeriodMilliseconds);
        });
    }

    function init() {
        setCaptchaTimeout(inputs[0], refreshButtons[0]);
        setCaptchaTimeout(inputs[1], refreshButtons[1]);
    }

    if (inputs.length) {
        init();
    }
})();
